// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__6DgrP","menu":"Header_menu__dGc7F","logo":"Header_logo__+i6Cv","icon":"Header_icon__8Ob9U","text":"Header_text__HMBYV"};